exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity .menu-wrapper {\n  max-height: 0;\n  overflow: hidden;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n}\n.activity .menu-wrapper.active {\n  max-height: 500px;\n}\n.item-link {\n  transition: all 0.4s ease-in-out;\n}\n.item-link:hover .icon-container {\n  background-color: #1C4C91;\n}\n.bg-gray-250 {\n  background-color: #EDF2FF;\n}\n.nav-item {\n  position: relative;\n}\n.nav-item .router-link-active {\n  color: #0669f9 !important;\n}", ""]);

// exports
